export const listaSiNo = [
    { label: 'NO', value: '0' },
    { label: 'SI', value: '1' }
]